import _styled from "styled-components";
import React, { memo, useContext } from 'react';
import Box from './Box';
import XIcon from './icons/XIcon';
import { OverlayContext } from './Overlay';
import Text from './Text';
import { ThemeContext } from './ThemeProvider';
const OverlayCloseButton = /*#__PURE__*/memo(() => {
  const {
    theme
  } = useContext(ThemeContext);
  const {
    onClose
  } = useContext(OverlayContext);
  return /*#__PURE__*/React.createElement(_StyledBox, {
    as: "button",
    onClick: onClose,
    $_css: theme.space[3],
    $_css2: theme.space[3],
    $_css3: theme.colors.white,
    $_css4: theme.colors.red
  }, /*#__PURE__*/React.createElement(XIcon, {
    size: 24
  }), /*#__PURE__*/React.createElement(Text, {
    fontSize: 14
  }, "ESC"));
});
OverlayCloseButton.propTypes = {};
OverlayCloseButton.defaultProps = {};
OverlayCloseButton.displayName = 'OverlayCloseButton';
export default OverlayCloseButton;
var _StyledBox = _styled(Box).withConfig({
  displayName: "OverlayCloseButton___StyledBox",
  componentId: "sc-rpn2x5-0"
})(p => ({
  all: 'unset',
  cursor: 'pointer',
  textAlign: 'center',
  position: 'absolute',
  top: p.$_css,
  right: p.$_css2,
  color: p.$_css3,
  '&:hover': {
    color: p.$_css4
  }
}));